// Чистая геометрия редактора: перевод между пикселями холста и мм контура.
// 100 SVG-units = 1 мм; s — px на единицу (this.fit.s).

export const clamp = (v, lo, hi) => Math.max(lo, Math.min(hi, v))

// Дельта в px → мм, округление до целого мм (для полей ввода).
export const pxToMm = (dpx, s) => Math.round(dpx / s / 100)

// Смещение в мм → дельта px.
export const mmToPx = (mm, s) => mm * 100 * s
